!function (n) {
  n.languages.haml = {
    "multiline-comment": {
      pattern: /((?:^|\r?\n|\r)([\t ]*))(?:\/|-#).*(?:(?:\r?\n|\r)\2[\t ].+)*/,
      lookbehind: !0,
      alias: "comment"
    },
    "multiline-code": [{
      pattern: /((?:^|\r?\n|\r)([\t ]*)(?:[~-]|[&!]?=)).*,[\t ]*(?:(?:\r?\n|\r)\2[\t ].*,[\t ]*)*(?:(?:\r?\n|\r)\2[\t ].+)/,
      lookbehind: !0,
      inside: n.languages.ruby
    }, {
      pattern: /((?:^|\r?\n|\r)([\t ]*)(?:[~-]|[&!]?=)).*\|[\t ]*(?:(?:\r?\n|\r)\2[\t ].*\|[\t ]*)*/,
      lookbehind: !0,
      inside: n.languages.ruby
    }],
    filter: {
      pattern: /((?:^|\r?\n|\r)([\t ]*)):[\w-]+(?:(?:\r?\n|\r)(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/,
      lookbehind: !0,
      inside: {
        "filter-name": {
          pattern: /^:[\w-]+/,
          alias: "symbol"
        }
      }
    },
    markup: {
      pattern: /((?:^|\r?\n|\r)[\t ]*)<.+/,
      lookbehind: !0,
      inside: n.languages.markup
    },
    doctype: {
      pattern: /((?:^|\r?\n|\r)[\t ]*)!!!(?: .+)?/,
      lookbehind: !0
    },
    tag: {
      pattern: /((?:^|\r?\n|\r)[\t ]*)[%.#][\w\-#.]*[\w\-](?:\([^)]+\)|\{(?:\{[^}]+\}|[^{}])+\}|\[[^\]]+\])*[\/<>]*/,
      lookbehind: !0,
      inside: {
        attributes: [{
          pattern: /(^|[^#])\{(?:\{[^}]+\}|[^{}])+\}/,
          lookbehind: !0,
          inside: n.languages.ruby
        }, {
          pattern: /\([^)]+\)/,
          inside: {
            "attr-value": {
              pattern: /(=\s*)(?:"(?:\\.|[^\\"\r\n])*"|[^)\s]+)/,
              lookbehind: !0
            },
            "attr-name": /[\w:-]+(?=\s*!?=|\s*[,)])/,
            punctuation: /[=(),]/
          }
        }, {
          pattern: /\[[^\]]+\]/,
          inside: n.languages.ruby
        }],
        punctuation: /[<>]/
      }
    },
    code: {
      pattern: /((?:^|\r?\n|\r)[\t ]*(?:[~-]|[&!]?=)).+/,
      lookbehind: !0,
      inside: n.languages.ruby
    },
    interpolation: {
      pattern: /#\{[^}]+\}/,
      inside: {
        delimiter: {
          pattern: /^#\{|\}$/,
          alias: "punctuation"
        },
        ruby: {
          pattern: /[\s\S]+/,
          inside: n.languages.ruby
        }
      }
    },
    punctuation: {
      pattern: /((?:^|\r?\n|\r)[\t ]*)[~=\-&!]+/,
      lookbehind: !0
    }
  };

  for (var e = ["css", {
    filter: "coffee",
    language: "coffeescript"
  }, "erb", "javascript", "less", "markdown", "ruby", "scss", "textile"], t = {}, r = 0, a = e.length; r < a; r++) {
    var i = e[r];
    i = "string" == typeof i ? {
      filter: i,
      language: i
    } : i, n.languages[i.language] && (t["filter-" + i.filter] = {
      pattern: RegExp("((?:^|\\r?\\n|\\r)([\\t ]*)):{{filter_name}}(?:(?:\\r?\\n|\\r)(?:\\2[\\t ].+|\\s*?(?=\\r?\\n|\\r)))+".replace("{{filter_name}}", function () {
        return i.filter;
      })),
      lookbehind: !0,
      inside: {
        "filter-name": {
          pattern: /^:[\w-]+/,
          alias: "symbol"
        },
        text: {
          pattern: /[\s\S]+/,
          alias: [i.language, "language-" + i.language],
          inside: n.languages[i.language]
        }
      }
    });
  }

  n.languages.insertBefore("haml", "filter", t);
}(Prism);